export default __webpack_public_path__ + "static/media/alert-illustration-shared.8c64988b.png";